/**
 * @GENERATED from Figma node 3638:51937
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const PhotoshopBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#0070E0"
      d="M6.333 14.413c3.659.02 5.41-1.868 5.41-4.788 0-2.783-1.79-4.71-5.507-4.71H1v13.878h2.51v-4.38zm-.097-7.318c1.985 0 2.958 1.032 2.958 2.53 0 1.694-1.051 2.608-2.9 2.608H3.511V7.095zM18.134 19.085c3.29 0 4.866-1.577 4.866-3.737 0-2.511-2.238-2.94-4.243-3.231-1.615-.234-3.056-.37-3.056-1.402 0-.778.506-1.343 2.083-1.343 1.48 0 2.219.487 2.394 1.577h2.608c-.312-2.219-1.79-3.62-4.983-3.62-3.075 0-4.612 1.498-4.612 3.542 0 2.51 2.238 2.939 4.242 3.231 1.596.233 3.037.37 3.037 1.401 0 .896-.642 1.44-2.277 1.44-1.577 0-2.511-.525-2.745-1.848h-2.763c.33 2.588 2.024 3.99 5.45 3.99"
    />
  </svg>
);
const ForwardRef = React.forwardRef(PhotoshopBright);
export { ForwardRef as PhotoshopBright };
